<template>
	<div class="main contentQuery">
		<div class="table-form">
			<div class="form-title">查看内容</div>
			<form class="query-form" action="javascript:void(0)" method="post">
				<table border="0" cellspacing="0" cellpadding="0">
					<colgroup width="70px"></colgroup>
					<colgroup></colgroup>
					<tr>
						<td><label>内容编号:</label></td>
						<td><span>{{contentInfo.id}}</span></td>
					</tr>
					<tr>
						<td><label>内容名称:</label></td>
						<td><span>{{contentInfo.contentname}}</span></td>
					</tr>
					<tr>
						<td><label>发布人员:</label></td>
						<td><span>{{contentInfo.publishername}}</span></td>
					</tr>
					<tr>
						<td><label>说明:</label></td>
						<td><span>{{contentInfo.remark}}</span></td>
					</tr>
					<tr>
						<td class="asset-label"><label>附件:</label></td>
						<td>
							<ul class="asset-list">
								<li class="soure" v-for="item in files.sourceUrls" @click="download(item)">
									<a href="javascript:void(0)"></a>
								</li>
								<li class="other" v-for="item in files.addresses" @click="query(item)">
									<a href="javascript:void(0)"></a>
								</li>
								<li class="other" v-for="item in files.connects" @click="connectq(item)">
									<a href="javascript:void(0)"></a>
								</li>
							</ul>
						</td>
					</tr>
					<tr>
						<td><label>标签:</label></td>
						<td>
							<ul class="tags-list">
								<li v-for="item in tags">
									<a target="_blank" :href="'/contentList?q='+item">{{item}}</a>
								</li>
							</ul>
						</td>
					</tr>
				</table>

				<!--<div class="tipCommon"></div>-->
			</form>
		</div>
		<form action="javascript:void(0)" class="comment-query" method="post">
			<div class="reply-text" v-if="reply.replyId">回复：{{reply.replyMan}}<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{reply.replyContent}}
				<a href="javascript:void(0)" class="reply-close" @click="replyClose">关闭回复</a>
			</div>
			<div class="comment-area">
				<textarea class="comment-text" name="comment-text" rows="" cols="" maxlength="140" v-model="commentText" placeholder="输入评论"></textarea>
				<div class="comment-tip"><span>{{commentText.length}}</span>/140</div>
			</div>
			<div>
				<input type="submit" class="comment-btn" @click="commentAdd" value="发送" />
			</div>
			<div class = "list-div">
				<ul class="comment-list">
					<li v-for="(item,index) in listFunData">
						<div class="reply-text" v-if="item.pname">{{item.pname}}:<br/>{{item.pcontent}}</div>
						<div>
							<div class="comment-box">
								<div class="comment-name">{{item.nickname}}：</div>
								<div class="comment-content"><span v-if="item.pname">回复&nbsp;&nbsp;<span style = "color: #5DACFF;">{{item.pname}}</span>&nbsp;&nbsp;</span>{{item.commentwords}}</div>
							</div>
							<ul class="comment-btn1">
								<li class="comment-del" @click = "delComment(item.id)" v-if="getLocalUser.id==item.commentator"></li>
								<li class="comment-msg" @click="msgSend(index)"></li>
							</ul>
						</div>
					</li>
				</ul>
				<div class = "list-processing" v-if = "listStatus">处理中...</div>
			</div>
			<div class="nodata2" v-if="listFunData.length<=0">暂无评论...</div>
			<pagination :total="count" :current-page='dataTable.currentPage' :totalPage='totalPage' @pagechange="pagechange" v-if="listFunData.length>0"></pagination>
		</form>
		<div class="login-copyright"> © 2018 zhiyun-tech.com All rights reserved. 桂林智神信息技术有限公司 桂ICP备15010724号-1</div>
	</div>
</template>

<script>
	import pagination from "@/components/pagination"
	export default {
		name: 'contentQuery',
		data() {
			return {
				commentText: "",
				listStatus:false,
				contentInfo: {
					id: "321321",
					contentname: "",
					remark: "",
					publishername: ""
				},
				reply: {
					replyId: 0,
					replyMan: "",
					replyContent: ""
				},
				files: {
					addresses: "",
					connects: "",
					sourceUrls: ""
				},
				tags: [],
				listFunData: [],
				totalPage: 1,
				count: 1,
				click: false,
				q: "",
				dataTable: {
					//总页数
					currentPage: 1,
					start: 0,
					pageSize: 6 //每页数据量
				}
			}
		},
		components: {
			pagination
		},
		created: function() {
			this.$nextTick(() => {
				this.common.get('content/queryById?id=' + this.$route.query.id, this.editCreate,{},false);
				this.init();
			})
		},
		mounted: function() {},
		methods: {
			editCreate: function(data) {
				if(data != null) {
					this.contentInfo = data.contentInfo[0]
					this.tags = data.tags;
					this.files = data.files
				}
			},
			msgSend: function(index) {
				$(".comment-text").focus()
				this.reply.replyId = this.listFunData[index].id
				this.reply.replyMan = this.listFunData[index].nickname;
				this.reply.replyContent = this.listFunData[index].commentwords;
			},
			goBack: function() {
				location.href = "/contentList"
			},
			download: function(imgPathURL) {
				window.open(imgPathURL);
			},
			query: function(imgPathURL) {
				window.open(imgPathURL);
			},
			connectq:function(id){
				window.open("/contentQuery?id="+id);
			},
			commentAdd: function() {
				if(this.commentText == "") {
					return this.layer.tips("请输入评论内容", ".comment-text", {
						tips: [2, '#FF9900'],
						time: 4000
					})
				}
				let params = {};
				let _this = this
				params.parentId = this.reply.replyId;
				params.commentWords = this.commentText;
				params.commentator = this.getLocalUser.id;
				params.contentId = this.$route.query.id;
				this.common.post('comment/addComment', function(ret){
					if(ret.errcode==0){
//						_this.start = 0;
						_this.commentText = "";
						_this.reply = {
							replyId: 0,
							replyMan: "",
							replyContent: ""
						}
						_this.refreshTable();
						_this.pagechange(Math.ceil(_this.count / _this.dataTable.pageSize))
					}
					if(ret.errcode==1014){
						_this.layer.alert("回复失败,当前回复已被删除")
					}
				}, params, false);
			},
			delComment:function(id){
				let params = {};
				params.userId = this.getLocalUser.id;
				params.id = id
				this.layer.confirm("是否要删除改评论",(index)=>{
					this.layer.close(index)
					this.common.get('comment/delComment?userId=' + this.getLocalUser.id + '&id=' + id, this.delRe);
				})
			},
			delRe:function(data){
				this.refreshTable();
			},
			replyClose: function() {
				this.reply = {
					replyId: 0,
					replyMan: "",
					replyContent: ""
				}
			},
			init: function() {
				if(localStorage.getItem("dataTable" + this.$route.name) != null) {
					this.dataTable = JSON.parse(localStorage.getItem("dataTable" + this.$route.name))
				}
				this.refreshTable();
			},
			listFun: function(data) {
				if(data && data.errcode == '0') {
					this.listStatus = false;
					this.totalPage = Math.ceil(data.count / this.dataTable.pageSize);
					this.count = data.count;
					if(this.click == true) {
						localStorage.setItem("dataTable" + this.$route.name, JSON.stringify(this.dataTable));
					}
					this.listFunData = data.list;
				}
			},
			pagechange: function(currentPage=1) {
				this.click = true;
				this.dataTable.currentPage = currentPage;
				this.dataTable.start = this.dataTable.pageSize * (currentPage - 1);
				this.refreshTable();
			},
			refreshTable: function(data) {
				data = {
					start: this.dataTable.start,
					limit: this.dataTable.pageSize,
					contentId:this.$route.query.id
				}
				this.common.get('comment/commentList', this.listFun, data,true,()=>{
					this.listStatus = true
				});
			},
			contentAddResult: function(data) {
				this.layer.alert("成功", function() {
					location.href = "/contentList"
				})
			}
		}

	}
</script>

<style>
	@import url("../../static/bower_components/Font-Awesome/css/font-awesome.css");
	@import url("../../static/css/editForm.css");
	.nodata2{
		display: table;
		margin: 0 auto;
		color: gray!important;
		font-size: 14px;
		margin-top: 10px;
	}
	.list-processing{
		font-size: 15px;
		color: #2c3e50;
		width: 200px;
		position: absolute;
		background: #fff;
		text-align: center;
		left: 50%;
		top: 50%;
		margin-left: -100px;
		margin-top: -26px;
	    padding: 1em 0;
	    border: 1px solid #ecf0f1;
	    border-radius: 4px;
	    -webkit-box-shadow: 0 1px 1px rgba(0,0,0,0.05);
	    box-shadow: 0 1px 1px rgba(0,0,0,0.05);
	}
</style>


// WEBPACK FOOTER //
// src/assets/contentQuery.vue